import { client, formatQueryParams } from 'util/sdk';

export default ({ fspId, id, ...params }) =>
  client
    .fsps(fspId)
    .recipientAuditLogs.query(
      formatQueryParams({ recipientId: id, ...params })
    );
